/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { Suspense, useEffect, useState } from 'react'
import Footer from '../../components/Footer'
import BottomFooter from '../../components/BottomFooter'
import Loader from '../../components/Loader'
import Slider from 'react-slick'
import { getApiWithData, notifyError, postApi } from '../../service'
import { USER_API } from '../../common/common'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Logout, getImageUrl } from '../../common/Funcation'
import Cookies from 'universal-cookie'
import { isMobile } from 'react-device-detect'
import { styleObjectGetBG } from '../../common/StyleSeter'
import { useDispatch, useSelector } from 'react-redux'
import GameCardSkeleton from '../../components/GameCardSkeleton'

const cookies = new Cookies()

function Casino() {
    const [isLoadingMain, setIsLoadingMain] = useState(true)
    const [activeCategory, setActiveCategory] = useState<any>('Popular')
    const [mainFilter, setMainFilter] = useState<any>("Catalog")
    const [secondFilter, setSecondFilter] = useState<any>('')
    const [allPlatforms, setAllPlatforms] = useState<any>({})
    const [searchActive, setSearchActive] = useState(false)
    // SN: Search functionality 
    const [searchText, setSearchText] = useState('');
    const [searchResults, setSearchResults] = useState<any[]>([]);
    const [casnioData, setCasnioData] = useState<any>()
    const DD = useSelector((e: any) => e.domainDetails);
    const casinoCache = useSelector((e: any) => e.casinoCache || {});
    const marketListDetails = useSelector((e: any) => e.marketListDetails);
    const dispatch = useDispatch();

    const getCasinoCacheKey = (type: string, filter: string, subName: string = "") =>
        `${type}:${filter}:${subName || ""}`;

    const getPlatformKey = (category: string) => {
        switch (category) {
            case "Live": return "LIVE";
            case "Table": return "TABLE";
            case "Slot": return "SLOT";
            case "Fishing": return "FH";
            case "Egame": return "EGAME";
            default: return "";
        }
    };

    const updatePlatforms = (platformsData: any) => {
        if (platformsData) {
            setAllPlatforms((prev: any) => ({ ...prev, ...platformsData }));
        }
    };

    const getCategoryPlatforms = (category: string) => {
        const key = getPlatformKey(category);
        if (!key) return [];
        return allPlatforms?.[key] || casnioData?.platforms?.[key] || [];
    };

    useEffect(() => {
        if (casinoCache) {
            for (const key of Object.keys(casinoCache)) {
                if (casinoCache[key]?.platforms) {
                    setAllPlatforms((prev: any) => ({ ...prev, ...casinoCache[key].platforms }));
                    break;
                }
            }
        }
    }, [casinoCache]);

    const onTabChange = (name: string) => {
        if (name === 'Popular') {
            setSecondFilter('');
            handleCasinoChange('Popular', '');
            return;
        }

        const platKey = getPlatformKey(name);
        const plats = allPlatforms?.[platKey] || casnioData?.platforms?.[platKey] || [];
        const firstPlatform = plats?.[0] || '';

        setSecondFilter(firstPlatform);
        handleCasinoChange(name, firstPlatform);
    };

    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const category = params.get('category');
    // console.log("category", category)
    const navigate = useNavigate()



    const whoitsforsettings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 5,
        variableWidth: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 450,
                settings: {
                    slidesToShow: 5.15,
                    slidesToScroll: 5.15,
                    dots: true,
                    variableWidth: false,
                    arrows: false,
                }
            },
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    arrows: false,
                    dots: true,
                    // variableWidth: false,
                }
            },
        ]
    };

    const subSliderSettings = {
        dots: false,
        infinite: false,
        speed: 500,
        variableWidth: true,
        arrows: false,
    }



    useEffect(() => {
        const token = cookies.get('skyTokenFront');

        if (!token) {
            navigate('/login', { replace: true });
            return;
        }

        if (category?.length) {
            setActiveCategory(category)
            getFirstTimeCasinoData(category)
        }
        else {
            getFirstTimeCasinoData(activeCategory)
        }
    }, [category])




    const getFirstTimeCasinoData = async (name: any) => {
        const defaultFilter =
            name === 'Popular' || name === 'Live'
                ? 'Catalog'
                : 'Catalog';
        setActiveCategory(name)
        setMainFilter(defaultFilter)

        let initialSubfilter = '';
        if (name !== 'Popular') {
            const platKey = getPlatformKey(name);
            const plats = allPlatforms?.[platKey] || casnioData?.platforms?.[platKey] || [];
            initialSubfilter = plats?.[0] || '';
            setSecondFilter(initialSubfilter);
        } else {
            setSecondFilter('');
        }

        const cacheKey = getCasinoCacheKey(name, defaultFilter, initialSubfilter || '')
        const cached = casinoCache[cacheKey]
        if (cached) {
            setCasnioData(cached)
            updatePlatforms(cached?.platforms)
            setIsLoadingMain(false)
            return
        }

        setIsLoadingMain(true)
        let data = {
            api: USER_API.GET_CASINO,
            value: {
                gameType: name,
                filter: defaultFilter,
                subName: initialSubfilter || '',
                domain: window.location.hostname
            },
        }
        await getApiWithData(data).then(function (response) {
            const resData = response?.data?.data;
            setCasnioData(resData)
            updatePlatforms(resData?.platforms)
            dispatch({
                type: "SET_GAME_DATA",
                payload: {
                    type: name,
                    filter: defaultFilter,
                    subName: initialSubfilter || '',
                    data: resData,
                },
            });

            if (name !== 'Popular' && !initialSubfilter) {
                const platKey = getPlatformKey(name);
                const first = resData?.platforms?.[platKey]?.[0];
                if (first) {
                    setSecondFilter(first);
                    handleSecondFilter(first, name);
                }
            }
        }).catch(err => {
            if (err.response.data.statusCode === 401) {
                Logout()
                navigate('/login')
            }
        }).finally(() => {
            setIsLoadingMain(false)
        })

    }


    const handleCasinoChange = async (name: any, subfilter: any) => {
        // Parse the current query parameters
        const params = new URLSearchParams(search);
        // Remove the 'category' parameter
        params.delete('category');
        // Update the URL without triggering a full page reload
        const newUrl = `${window.location.pathname}`;
        window.history.replaceState({}, '', newUrl);

        setActiveCategory(name)
        const defaultFilter =
            name === 'Popular' || name === 'Live'
                ? 'Catalog'
                : 'Catalog';

        setMainFilter(defaultFilter);
        setSecondFilter(subfilter || '');

        const cacheKey = getCasinoCacheKey(name, defaultFilter, subfilter || '')
        const cached = casinoCache[cacheKey]
        if (cached) {
            setCasnioData(cached)
            updatePlatforms(cached?.platforms)
            setIsLoadingMain(false)
            return
        }

        setIsLoadingMain(true)
        let data = {
            api: USER_API.GET_CASINO,
            value: {
                gameType: name,
                filter: defaultFilter,
                subName: subfilter || '',
                domain: window.location.hostname

            },
        }
        await getApiWithData(data).then(function (response) {
            const resData = response?.data?.data;
            setCasnioData(resData)
            updatePlatforms(resData?.platforms)
            dispatch({
                type: "SET_GAME_DATA",
                payload: {
                    type: name,
                    filter: defaultFilter,
                    subName: subfilter || '',
                    data: resData,
                },
            });

            if (name !== 'Popular' && !subfilter) {
                const platKey = getPlatformKey(name);
                const first = resData?.platforms?.[platKey]?.[0];
                if (first) {
                    setSecondFilter(first);
                    handleSecondFilter(first, name);
                }
            }
        }).catch(err => {
            if (err.response.data.statusCode === 401) {
                Logout()
                navigate('/login')
            }
        }).finally(() => {
            setIsLoadingMain(false)
        })
    }


    const handleMainFilter = async (name: any) => {
        setMainFilter(name)
        const cacheKey = getCasinoCacheKey(activeCategory, name, secondFilter || '')
        const cached = casinoCache[cacheKey]
        if (cached) {
            setCasnioData(cached)
            updatePlatforms(cached?.platforms)
            setIsLoadingMain(false)
            return
        }

        setIsLoadingMain(true)
        let data = {
            api: USER_API.GET_CASINO,
            value: {
                gameType: activeCategory,
                filter: name,
                subName: secondFilter || '',
                domain: window.location.hostname
            },
        }
        await getApiWithData(data).then(function (response) {
            const resData = response?.data?.data;
            setCasnioData(resData)
            updatePlatforms(resData?.platforms)
            dispatch({
                type: "SET_GAME_DATA",
                payload: {
                    type: activeCategory,
                    filter: name,
                    subName: secondFilter || '',
                    data: resData,
                },
            });
        }).catch(err => {
            if (err.response.data.statusCode === 401) {
                Logout()
                navigate('/login')
            }
        }).finally(() => {
            setIsLoadingMain(false)
        })
    }


    const handleSecondFilter = async (name: any, categoryName?: string) => {
        const cat = categoryName || activeCategory;
        const currentFilter = mainFilter || 'Catalog';
        setSecondFilter(name)
        const cacheKey = getCasinoCacheKey(cat, currentFilter, name || '')
        const cached = casinoCache[cacheKey]
        if (cached) {
            setCasnioData(cached)
            updatePlatforms(cached?.platforms)
            setIsLoadingMain(false)
            return
        }

        setIsLoadingMain(true)
        let data = {
            api: USER_API.GET_CASINO,
            value: {
                gameType: cat,
                filter: currentFilter,
                subName: name,
                domain: window.location.hostname
            },
        }
        await getApiWithData(data).then(function (response) {
            const resData = response?.data?.data;
            setCasnioData(resData)
            updatePlatforms(resData?.platforms)
            dispatch({
                type: "SET_GAME_DATA",
                payload: {
                    type: cat,
                    filter: currentFilter,
                    subName: name || '',
                    data: resData,
                },
            });
        }).catch(err => {
            if (err.response.data.statusCode === 401) {
                Logout()
                navigate('/login')
            }
        }).finally(() => {
            setIsLoadingMain(false)
        })
    }







    const getCasinoLink = async (item: any) => {
        const casinoBlocked = marketListDetails?.data?.some(
            (m: any) => m?.name === "Casino" && m.isBlock
        );
        if (casinoBlocked) {
            notifyError("Your casino is block, Contact to your upline.");
            return;
        }
        if (cookies.get('skyTokenFront')) {
            let data = {
                api: USER_API.CASINO_LOGIN,
                value: {
                    id: item._id,
                    isMobileLogin: isMobile ? true : false,
                    domain: window.location.hostname === "localhost" ? 'taka365.win' : window.location.hostname
                },
                token: cookies.get('skyTokenFront') ? cookies.get('skyTokenFront') : '',
            }

            await postApi(data).then(function (response) {
                window.open(response?.data?.data?.url, '_blank');
            }).catch(err => {
                // console.log(err);
                notifyError(err?.response?.data?.message)

                if (err.response.data.statusCode === 401) {
                    Logout()
                    // notifyError('Pin unsuccess')
                    // navigate('/login')
                }
            })
        } else {
            // if (isMobile) { navigate('/login') }
            if (isMobile) { window.location.pathname = '/login' }
            notifyError('please login first')
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            const searchValue = searchText.trim().toLowerCase();

            // Empty search
            if (!searchValue) {
                setSearchResults([]);
                return;
            }

            const results = casnioData?.casinoType?.filter((item: any) =>
                item?.title?.toLowerCase().includes(searchValue)
            ) || [];

            setSearchResults(results);
        }, 300);

        return () => clearTimeout(timer);
    }, [searchText, casnioData]);



    return (
        <>


            <div className='full-wrap bottomfooter fade-in-transition'>
                <style>
                    {`
                    @keyframes select {
  0% {
    transform: scale(0.8);
  }

  45% {
    transform: scale(1.1);
  }

  90% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes deselect {
  0% {
    transform: scale(1);
  }

  40% {
    transform: scale(0);
  }

  70% {
    transform: scale(1.3);
  }

  100% {
    transform: scale(1);
  }
}

.casino .games-slot-item .tab-icon-animate {
  animation: select 0.25s linear;
}

.casino .games-slot-item .tab-icon-animate-reverse {
  animation: deselect 0.25s linear;
}

.casino .games-slot {
    margin-top: 0;
    background-image: url(data:image/png;base64,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);
    background-size: contain;
    color: #946f3b;
    padding: 0.625rem 0 1.4285714286rem 0;
}
    @media (max-width: 576px) {
    .games-slot {
        height: 101.91px;
    }
}
    @media (max-width: 480px) {
    .casino .games-slot-item img {
        max-width: 55.11px;
        width: 55.11px;
        height: auto;
        margin-top: 0.5rem
    }
}
    .casino .games-slot-item.active h6 {
    color: #FFE0A7;
}
@media (max-width: 480px) {
    .casino .games-slot-item h6 {
        font-size: 12.48px !important;
        line-height: 12.48px !important;
        margin-bottom: 0;
    }
}
    .casino .games-slot-item h6 {
    color: #946F3B;
}
    @media (max-width: 576px) {
    .games-slot-item {
        height: 74.88px;
    }
}
    @media (max-width: 576px) {
    .games-slot .slick-list, .games-slot .slick-track {
        height: 74.88px;
    }
}
    .games-slot .slick-dots li.slick-active button:before {
    width: 20.8px;
    height: 6.24px;
    border-radius: .25rem;
    background: #FFE0A7;
}
    .games-slot .slick-dots li button:before {
    background: #946F3B;
}
    .casino .main-casino-wrapper .casinofilter span {
    font-weight: 700;
    font-size: 13.52px;
    font-family: "Ubuntu", sans-serif;
}
    .casino .subcasino span {
    border-radius: .25rem;
    font-weight: 700;
    font-size: 13.52px;
    padding: 2px 15px;
}
`}
                </style>
                <div className='casino'>
                    <div className='games-slot'>
                        <Slider  {...whoitsforsettings}>
                            <div className={` games-slot-item ${activeCategory === 'Popular' ? "active" : ""} `} onClick={() => onTabChange('Popular')}>
                                <div>
                                    <h6>Popular</h6>
                                    {activeCategory === 'Popular' ?
                                        <img key="popular-active" src="./images/casino-icon/hover-popular.svg" alt="" className="tab-icon-animate" />
                                        :
                                        <img key="popular-inactive" src="./images/casino-icon/popular.svg" alt="" className="tab-icon-animate-reverse" />
                                    }
                                </div>
                            </div>
                            <div className={` games-slot-item ${activeCategory === 'Live' ? "active" : ""} `} onClick={() => onTabChange('Live')}>
                                <div>
                                    <h6>Live</h6>
                                    {activeCategory === 'Live' ?
                                        <img key="live-active" src="./images/casino-icon/hover-live.svg" alt="" className="tab-icon-animate" />
                                        :
                                        <img key="live-inactive" src="./images/casino-icon/icon-live.svg" alt="" className="tab-icon-animate-reverse" />
                                    }
                                </div>
                            </div>
                            <div className={` games-slot-item ${activeCategory === 'Table' ? "active" : ""} `} onClick={() => onTabChange('Table')}>
                                <div>
                                    <h6>Table</h6>
                                    {activeCategory === 'Table' ?
                                        <img key="table-active" src="./images/casino-icon/hover-table.svg" alt="" className="tab-icon-animate" />
                                        :
                                        <img key="table-inactive" src="./images/casino-icon/icon-table.svg" alt="" className="tab-icon-animate-reverse" />
                                    }
                                </div>
                            </div>
                            <div className={` games-slot-item ${activeCategory === 'Slot' ? "active" : ""} `} onClick={() => onTabChange('Slot')}>
                                <div>
                                    <h6>Slot</h6>
                                    {activeCategory === 'Slot' ?
                                        <img key="slot-active" src="./images/casino-icon/hover-slot.svg" alt="" className="tab-icon-animate" />
                                        :
                                        <img key="slot-inactive" src="./images/casino-icon/icon-slot.svg" alt="" className="tab-icon-animate-reverse" />
                                    }
                                </div>
                            </div>
                            <div className={` games-slot-item ${activeCategory === 'Fishing' ? "active" : ""} `} onClick={() => onTabChange('Fishing')}>
                                <div>
                                    <h6>Fishing</h6>
                                    {activeCategory === 'Fishing' ?
                                        <img key="fishing-active" src="./images/casino-icon/hover-fishing.svg" alt="" className="tab-icon-animate" />
                                        :
                                        <img key="fishing-inactive" src="./images/casino-icon/icon-fishing.svg" alt="" className="tab-icon-animate-reverse" />
                                    }
                                </div>
                            </div>
                            <div className={`games-slot-item ${activeCategory === 'Egame' ? "active" : ""} `} onClick={() => onTabChange('Egame')}>
                                <div>
                                    <h6>Egame</h6>
                                    {activeCategory === 'Egame' ?
                                        <img key="egame-active" src="./images/casino-icon/hover-egame.svg" alt="" className="tab-icon-animate" />
                                        :
                                        <img key="egame-inactive" src="./images/casino-icon/egame.svg" alt="" className="tab-icon-animate-reverse" />
                                    }
                                </div>
                            </div>
                        </Slider>
                    </div>


                    {/* second filter  */}
                    {activeCategory !== 'Popular' &&
                        <div className="subcasino" style={{ padding: "6.24px 0" }}>
                            <div style={{ display: "flex", flexWrap: "wrap", rowGap: "6.24px" }}>
                                {getCategoryPlatforms(activeCategory)?.map((item: any, i: number) => (
                                    <span
                                        key={i}
                                        onClick={() => handleSecondFilter(item)}
                                        className={`${secondFilter === item ? 'active' : ''}`}
                                        style={secondFilter === item ? styleObjectGetBG(DD?.colorSchema, false, true) : {}}
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>
                        </div>
                    }


                    <div className='main-casino-wrapper'>


                        {/* search seciton  */}
                        <div className={`search-games-sec ${searchActive ? 'search-enters' : 'search-exits'}`}>
                            <form className="">
                                <div className="position-relative">
                                    <input placeholder="Search platform, games, and more......" type="text" className="form-control" value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)} />
                                    <button type="button" className="bg-transparent border-0 text-dark position-absolute end-0 top-7 pt-0 fs-4 btn btn-primary" onClick={() => { setSearchActive(false); setSearchText('') }}>
                                        <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div className="search-listing mt-sm-3 ">
                                    <ul className="p-0 m-0">
                                        <div className="w-100 mb-3 match-list">

                                            {searchText.trim() !== "" && (
                                                <>
                                                    {searchResults.length > 0 ? (
                                                        <div className="games-wrapper casino-all-games active">
                                                            <div className="games-card-inner" style={{ padding: 0 }}>
                                                                <div className="row">
                                                                    {searchResults.map((item: any, index: number) => (
                                                                        <div
                                                                            className="game-card position-relative"
                                                                            key={index}
                                                                        >
                                                                            <span className="lazy-load-image-background opacity lazy-load-image-loaded">
                                                                                <img
                                                                                    src={getImageUrl(item?.image)}
                                                                                    alt="game"
                                                                                    onClick={() => getCasinoLink(item)}
                                                                                    onError={(e: any) => e.currentTarget.src = "/images/photo-placeholder.jpg"}
                                                                                />
                                                                            </span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="no-event-outer">
                                                            <div className="no-event">
                                                                <svg
                                                                    stroke="currentColor"
                                                                    fill="currentColor"
                                                                    strokeWidth="0"
                                                                    viewBox="0 0 24 24"
                                                                    color="lightgrey"
                                                                    className="mb-2"
                                                                    height="55"
                                                                    width="55"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path d="M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"></path>
                                                                </svg>
                                                                No Event
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>

                                    </ul>
                                </div>
                            </form>
                        </div>

                        {/* main filter  and search button*/}
                        <div className="casinofilter d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                                {/* {(activeCategory === 'Popular' || activeCategory === 'Live') &&
                                    <span className={`${mainFilter === 'Catalog' ? 'active' : ''}`} style={mainFilter === 'Catalog' ? styleObjectGetBG(DD?.colorSchema, false, true) : {}} onClick={() => handleMainFilter('Catalog')} >Catalog</span>} */}
                                <span className={`${mainFilter === 'Catalog' ? 'active' : ''}`} style={mainFilter === 'Catalog' ? styleObjectGetBG(DD?.colorSchema, false, true) : {}} onClick={() => handleMainFilter('Catalog')} >Catalog</span>
                                <span className={`${mainFilter === 'latest' ? 'active' : ''}`} style={mainFilter === 'latest' ? styleObjectGetBG(DD?.colorSchema, false, true) : {}} onClick={() => handleMainFilter('latest')}>Latest</span>
                                <span className={`${mainFilter === 'a-z' ? 'active' : ''}`} style={mainFilter === 'a-z' ? styleObjectGetBG(DD?.colorSchema, false, true) : {}} onClick={() => handleMainFilter('a-z')}>A-Z</span>
                            </div>
                            <button type="button" className="bg-transparent border-0 text-dark btn btn-primary" onClick={() => setSearchActive(true)}>
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="40" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style={{ fontSize: "23px" }}>
                                    <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
                                </svg>
                            </button>
                        </div>

                        {isLoadingMain ? (
                            <GameCardSkeleton />
                        ) : (
                            <div className="games-wrapper casino-all-games active">

                                {casnioData?.casinoType?.length > 0 ? (

                                    (activeCategory === 'Popular' || activeCategory === 'Live') && mainFilter === 'Catalog' ? (

                                        <>
                                            {casnioData?.catalog?.length > 0 &&
                                                [
                                                    ...casnioData.catalog.filter((item: any) => item !== ""),
                                                    ...casnioData.catalog.filter((item: any) => item === "")
                                                ].map((item: any, i: number) => (

                                                    <div className="games-card-inner" key={i}>

                                                        <h2 style={styleObjectGetBG(DD?.colorSchema, false, true)}>
                                                            {item ? item : "Other"}
                                                        </h2>

                                                        <div className="row bg-white">

                                                            {casnioData?.casinoType
                                                                ?.filter((casinoItem: any) => casinoItem.catalog === item)
                                                                .map((catalogItem: any, index: number) => (

                                                                    <div
                                                                        className="game-card position-relative"
                                                                        key={index}
                                                                        style={catalogItem?.Width == "squareSize" ? {} : { width: "100%", aspectRatio: "auto" }}
                                                                    >
                                                                        <span className="lazy-load-image-background opacity lazy-load-image-loaded">
                                                                            <img
                                                                                src={getImageUrl(catalogItem?.image)}
                                                                                alt="game"
                                                                                onClick={() => getCasinoLink(catalogItem)}
                                                                                onError={(e: any) => e.currentTarget.src = "/images/photo-placeholder.jpg"}
                                                                            />
                                                                        </span>
                                                                    </div>

                                                                ))}

                                                        </div>
                                                    </div>

                                                ))}
                                        </>

                                    ) : (

                                        <div className="games-card-inner">

                                            <div className="row bg-white">

                                                {casnioData?.casinoType?.map((item: any, i: number) => (

                                                    <div
                                                        className="game-card position-relative"
                                                        key={i}
                                                        style={item?.Width == "squareSize" ? {} : { width: "100%", aspectRatio: "auto" }}
                                                    >
                                                        <span className="lazy-load-image-background opacity lazy-load-image-loaded">
                                                            <img
                                                                src={getImageUrl(item?.image)}
                                                                alt="game"
                                                                onClick={() => getCasinoLink(item)}
                                                                onError={(e: any) => e.currentTarget.src = "/images/photo-placeholder.jpg"}
                                                            />
                                                        </span>
                                                    </div>

                                                ))}

                                            </div>

                                        </div>

                                    )

                                ) : (

                                    <div className="no-data-container">
                                        <div className="no-data-content">
                                            <div className='no-data-icon'></div>
                                            <p>No Data</p>
                                        </div>
                                    </div>

                                )}

                            </div>
                        )}




                        <Footer />

                    </div>
                </div>

            </div >
            <BottomFooter />



        </>
    )
}

export default Casino